export default __webpack_public_path__ + "static/media/hierros-detalle.8026ba5b.png";